var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSmallGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 11.25C8.13807 11.25 8.25 11.3619 8.25 11.5C8.25 11.6381 8.13807 11.75 8 11.75C7.86193 11.75 7.75 11.6381 7.75 11.5C7.75 11.3619 7.86193 11.25 8 11.25ZM8.25 9C8.25 9.13807 8.13807 9.25 8 9.25C7.86193 9.25 7.75 9.13807 7.75 9V4.5C7.75 4.36193 7.86193 4.25 8 4.25C8.13807 4.25 8.25 4.36193 8.25 4.5V9Z",
    fill: "#737373",
    stroke: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmallGray);
export default __webpack_public_path__ + "static/media/infoSmallGray.c02eced2edfb3d9c9807e26c161134a5.svg";
export { ForwardRef as ReactComponent };